// Third Party
import * as React from 'react';

// Utils
import { useToggle } from '@hooks';

export type MobileSearchModalContextValue = {
  activateMobileSearchModal: VoidFunction;
  deactivateMobileSearchModal: VoidFunction;
  mobileSearchModalActive: boolean;
};

interface Props {
  children: React.ReactNode;
}

export const MobileSearchModalProvider: React.FC<Props> = ({ children }) => {
  const {
    on: mobileSearchModalActive,
    setOn: activateMobileSearchModal,
    setOff: deactivateMobileSearchModal,
  } = useToggle(false);

  const contextValue: MobileSearchModalContextValue = {
    activateMobileSearchModal,
    deactivateMobileSearchModal,
    mobileSearchModalActive,
  };

  return (
    <MobileSearchModalContext.Provider value={contextValue}>
      {children}
    </MobileSearchModalContext.Provider>
  );
};

export const MobileSearchModalContext = React.createContext<
  MobileSearchModalContextValue | undefined
>(undefined);

export const useMobileSearchModal = () => {
  const context = React.useContext(MobileSearchModalContext);

  if (context === undefined) {
    throw new Error(
      'useMobileSearchModal must be used within a MobileSearchModalProvider'
    );
  }

  return context;
};
